{
  "version": 1,
  "asset_id": "f21acc13-46c6-4954-89bb-2fc9968dd20c",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/f21acc13-46c6-4954-89bb-2fc9968dd20c/dilated-pouch-boxed-en-980.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/f21acc13-46c6-4954-89bb-2fc9968dd20c/dilated-pouch-boxed-en-980.webp",
  "original_filename": "dilated-pouch-boxed-en-980.webp",
  "size": 48322,
  "content_type": "image/webp",
  "created_at": "2026-10-06T14:27:49Z"
}
